"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import AppointmentCard from "../AppointmentCard/AppointmentCard";
import "./PendingRequestsHero.css";

export default function PendingRequestsHero({
  items = [],
  busy = {},
  onConfirm,
  onCancel,
  onReschedule,
  medecinId,
}) {
  const { t } = useTranslation("appointments");

  const pendingItems = items.filter((r) => {
    const status = String(r.status || "").toLowerCase();
    return status === "pending" || status === "scheduled";
  });

  return (
    <section className="pending-hero">
      <div className="pending-hero__header">
        <div className="pending-hero__title-side">
          <div className="pending-hero__icon">!</div>

          <div>
            <h3>{t("pending.title")}</h3>
            <p>{t("pending.subtitle", { count: pendingItems.length })}</p>
          </div>
        </div>

        <span className="pending-hero__badge">
          {t("pending.badge", { count: pendingItems.length })}
        </span>
      </div>

      {pendingItems.length > 0 ? (
        <div className="pending-hero__grid">
          {pendingItems.slice(0, 3).map((r) => (
            <AppointmentCard
              key={r.id}
              item={r}
              medecinId={medecinId}
              busy={busy[String(r.id)]}
              onConfirm={() => onConfirm(r)}
              onCancel={() => onCancel(r)}
              onReschedule={onReschedule}
            />
          ))}
        </div>
      ) : (
        <div className="pending-hero__empty">
          {t("pending.empty")}
        </div>
      )}
    </section>
  );
}